
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/ua/guidelines",
      function () {
        return require("private-next-pages/ua/guidelines.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/ua/guidelines"])
      });
    }
  